import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/solid'
import Translation from 'components/Translation'
import { Tier } from 'context/AppContext'
import { useAuth } from 'context/AuthContext'
import { useTenantContext } from 'context/TenantContext'
import Cookies from 'js-cookie'
import React, { Fragment, MouseEvent } from 'react'
import { Tenant } from 'types/tenant'
import { classNames } from 'utils/dom-helpers'

interface TenantSelectorProps {
    tenant?: Tenant
    tenants?: Tenant[]
    translations: Record<string, string>
}

export function TenantSelector({
    tenant,
    tenants,
    translations,
}: TenantSelectorProps) {
    const { TenantModal, is_drawer_expanded } = useAuth()
    const { setTenant } = useTenantContext()
    const imageWidth = is_drawer_expanded ? "h-7 w-7" : "h-8 w-8"

    function switchTenant(e: MouseEvent<HTMLButtonElement>) {
        if (tenants) {
            const t = tenants[e.currentTarget.value as unknown as number]
            Cookies.set('tenant_id', t.id)
            setTenant(t)
        }
    }

    function handleSignup() {
        TenantModal.setAttributes({ tier: tenant?.tier as Tier })
        TenantModal.open()
    }

    return (
        <div className="flex items-center gap-2"
        >
            {' '}
            <span
            >
                {tenant?.bizLogoUrl ? (
                    <img
                        src={tenant?.bizLogoUrl}
                        alt="Tenant Logo"
                        className= {classNames(
                            imageWidth,
                            'rounded-md'
                        )}
                    />
                ) : (
                    <div className={classNames(
                        imageWidth,
                        "rounded-md bg-white inline-block"
                    )} />
                )}
            </span>
            <span className="flex-grow text-left text-white font-bold">
                <div>{tenant?.name}</div>
            </span>
        </div>
    )
}
export default TenantSelector
